<template>
  <div class="terms-page">
    <v-container class="container-main">
      <v-row justify="center">
        <v-col cols="12" sm="11" md="10">

          <nav class="breadcrumb" aria-label="breadcrumb">
            <router-link to="/" class="breadcrumb-link">Home</router-link>
            <span class="breadcrumb-sep">/</span>
            <span class="breadcrumb-current">Terms and Conditions</span>
          </nav>

          <h1 class="page-title">Terms and Conditions</h1>

          <!-- EN -->
          <div v-if="lang === 'En'" class="legal-content" lang="en">

            <section>
              <h2>1. General Information</h2>
              <p>This website (the "Website"), available at <strong>www.investbroker.md</strong>, is operated by <strong>INVEST-BROKER S.R.L.</strong>, with registered office at:</p>
              <p>31 August 1989 St., no. 31, Chișinău MD-2001, Republic of Moldova.</p>
              <p>License: seria CNPF nr. 000867, issued on 22.03.2013.</p>
              <p>By accessing and using this Website, you (the "User", "Client" or "Buyer") agree to comply with these Terms and Conditions (the "Agreement").</p>
            </section>

            <section>
              <h2>2. Scope of Use</h2>
              <p>The Website serves an informational purpose and facilitates communication between users and the company.</p>
              <p>Use of the Website is permitted for lawful purposes only. The User agrees not to:</p>
              <ul>
                <li>use the Website in a manner that violates applicable legislation;</li>
                <li>attempt unauthorized access to systems or data;</li>
                <li>interfere with the operation or security of the Website.</li>
              </ul>
            </section>

            <section>
              <h2>3. Intellectual Property</h2>
              <p>All content on the Website, including but not limited to texts, graphics, logos, design and structure, belongs to <strong>INVEST-BROKER S.R.L.</strong> or its partners and is protected by intellectual property legislation.</p>
              <p>Reproduction, distribution, modification or use of content without prior written consent is prohibited.</p>
            </section>

            <section>
              <h2>4. Accuracy of Information</h2>
              <p>The information presented on the Website is for general informational purposes only.</p>
              <p>Although INVEST-BROKER S.R.L. makes reasonable efforts to ensure its accuracy, it does not guarantee that the information is complete, accurate or up to date at all times.</p>
              <p>The company reserves the right to modify, update or remove content at any time without prior notice.</p>
            </section>

            <section>
              <h2>5. Limitation of Liability</h2>
              <p>To the maximum extent permitted by law, INVEST-BROKER S.R.L. shall not be liable for:</p>
              <ul>
                <li>any direct or indirect damages resulting from the use or inability to use the Website;</li>
                <li>errors or omissions in the content;</li>
                <li>interruptions, delays or technical issues.</li>
              </ul>
              <p>Use of the Website is at the user's own risk.</p>
            </section>

            <section>
              <h2>6. Personal Data Protection</h2>
              <p>The Website complies with:</p>
              <ul>
                <li><strong>Law No. 133 of 08.07.2011 on the protection of personal data (Republic of Moldova)</strong>;</li>
                <li><strong>General Data Protection Regulation (GDPR)</strong>, where applicable.</li>
              </ul>
              <p>Personal data is processed lawfully, fairly and transparently.</p>
              <p>Users have the right to:</p>
              <ul>
                <li>access their personal data;</li>
                <li>request rectification or erasure;</li>
                <li>restrict or object to processing;</li>
                <li>withdraw consent, where applicable.</li>
              </ul>
              <p>For any requests regarding personal data: <strong>contact@investbroker.com</strong></p>
            </section>

            <section>
              <h2>7. Cookies &amp; Analytics</h2>
              <p>The Website uses cookies and third-party tools, including <strong>Google Analytics</strong>, for:</p>
              <ul>
                <li>improving the user experience;</li>
                <li>analyzing traffic and behavior on the Website.</li>
              </ul>
              <p>By using the Website, you consent to the use of cookies. They can be managed or disabled in your browser settings.</p>
            </section>

            <section>
              <h2>8. Third-Party Links</h2>
              <p>The Website may contain links to third-party websites.</p>
              <p>These are provided for convenience only, and INVEST-BROKER S.R.L. is not responsible for their content or policies.</p>
            </section>

            <section>
              <h2>9. Modifications</h2>
              <p>The company reserves the right to modify these Terms and Conditions at any time without prior notice.</p>
              <p>Continued use of the Website constitutes acceptance of the changes.</p>
            </section>

            <section>
              <h2>10. Governing Law</h2>
              <p>These Terms and Conditions are governed by the laws of the Republic of Moldova.</p>
              <p>Any disputes shall be resolved by the competent courts of the Republic of Moldova.</p>
            </section>

            <section>
              <h2>11. Contact Information</h2>
              <div class="contact-block">
                <p>For questions or requests related to these Terms and Conditions:</p>
                <p><strong>contact@investbroker.com</strong></p>
              </div>
            </section>
          </div>

          <!-- RO -->
          <div v-else-if="lang === 'Ro'" class="legal-content" lang="ro">

            <section>
              <h2>1. Informații generale</h2>
              <p>Acest website („Site-ul"), disponibil la adresa <strong>www.investbroker.md</strong>, este operat de <strong>INVEST-BROKER S.R.L.</strong>, cu sediul la:</p>
              <p>str. 31 August 1989, nr. 31, Chișinău MD-2001, Republica Moldova.</p>
              <p>Licență: seria CNPF nr. 000867, emisă la data de 22.03.2013.</p>
              <p>Prin accesarea și utilizarea acestui Site, dumneavoastră („Utilizatorul", „Clientul" sau „Cumpărătorul") acceptați să respectați acești Termeni și Condiții („Acordul").</p>
            </section>

            <section>
              <h2>2. Domeniul de utilizare</h2>
              <p>Site-ul are scop informativ și facilitează comunicarea între utilizatori și companie.</p>
              <p>Utilizarea Site-ului este permisă doar în scopuri legale. Utilizatorul se obligă să nu:</p>
              <ul>
                <li>utilizeze Site-ul într-un mod care încalcă legislația aplicabilă;</li>
                <li>încerce accesarea neautorizată a sistemelor sau datelor;</li>
                <li>afecteze funcționarea sau securitatea Site-ului.</li>
              </ul>
            </section>

            <section>
              <h2>3. Proprietate intelectuală</h2>
              <p>Tot conținutul Site-ului, inclusiv, dar fără a se limita la texte, grafice, logo-uri, design și structură, aparține <strong>INVEST-BROKER S.R.L.</strong> sau partenerilor săi și este protejat de legislația privind proprietatea intelectuală.</p>
              <p>Este interzisă reproducerea, distribuirea, modificarea sau utilizarea conținutului fără acordul prealabil scris.</p>
            </section>

            <section>
              <h2>4. Exactitatea informațiilor</h2>
              <p>Informațiile prezentate pe Site au caracter general informativ.</p>
              <p>Deși INVEST-BROKER S.R.L. depune eforturi rezonabile pentru a asigura corectitudinea acestora, nu garantează că informațiile sunt complete, exacte sau actualizate în permanență.</p>
              <p>Compania își rezervă dreptul de a modifica, actualiza sau elimina conținutul în orice moment, fără notificare prealabilă.</p>
            </section>

            <section>
              <h2>5. Limitarea răspunderii</h2>
              <p>În măsura maxim permisă de lege, INVEST-BROKER S.R.L. nu va fi responsabilă pentru:</p>
              <ul>
                <li>orice daune directe sau indirecte rezultate din utilizarea sau imposibilitatea utilizării Site-ului;</li>
                <li>erori sau omisiuni în conținut;</li>
                <li>întreruperi, întârzieri sau probleme tehnice.</li>
              </ul>
              <p>Utilizarea Site-ului se face pe propria răspundere.</p>
            </section>

            <section>
              <h2>6. Protecția datelor cu caracter personal</h2>
              <p>Site-ul respectă:</p>
              <ul>
                <li><strong>Legea nr. 133 din 08.07.2011 privind protecția datelor cu caracter personal (Republica Moldova)</strong>;</li>
                <li><strong>Regulamentul General privind Protecția Datelor (GDPR)</strong>, acolo unde este aplicabil.</li>
              </ul>
              <p>Datele cu caracter personal sunt prelucrate în mod legal, echitabil și transparent.</p>
              <p>Utilizatorii au dreptul de a:</p>
              <ul>
                <li>accesa datele personale;</li>
                <li>solicita rectificarea sau ștergerea acestora;</li>
                <li>restricționa sau opune prelucrării;</li>
                <li>retrage consimțământul, unde este cazul.</li>
              </ul>
              <p>Pentru orice solicitare privind datele personale: <strong>contact@investbroker.com</strong></p>
            </section>

            <section>
              <h2>7. Cookie-uri și analiză</h2>
              <p>Site-ul utilizează cookie-uri și instrumente terțe, inclusiv <strong>Google Analytics</strong>, pentru:</p>
              <ul>
                <li>îmbunătățirea experienței utilizatorului;</li>
                <li>analiza traficului și comportamentului pe Site.</li>
              </ul>
              <p>Prin utilizarea Site-ului, vă exprimați acordul pentru utilizarea cookie-urilor. Acestea pot fi gestionate sau dezactivate din setările browserului.</p>
            </section>

            <section>
              <h2>8. Link-uri către terți</h2>
              <p>Site-ul poate conține link-uri către site-uri ale terților.</p>
              <p>Acestea sunt furnizate doar pentru comoditate, iar INVEST-BROKER S.R.L. nu este responsabilă pentru conținutul sau politicile acestora.</p>
            </section>

            <section>
              <h2>9. Modificări</h2>
              <p>Compania își rezervă dreptul de a modifica acești Termeni și Condiții în orice moment, fără notificare prealabilă.</p>
              <p>Continuarea utilizării Site-ului reprezintă acceptarea modificărilor.</p>
            </section>

            <section>
              <h2>10. Legea aplicabilă</h2>
              <p>Acești Termeni și Condiții sunt guvernați de legislația Republicii Moldova.</p>
              <p>Orice litigiu va fi soluționat de instanțele competente din Republica Moldova.</p>
            </section>

            <section>
              <h2>11. Date de contact</h2>
              <div class="contact-block">
                <p>Pentru întrebări sau solicitări legate de acești Termeni și Condiții:</p>
                <p><strong>contact@investbroker.com</strong></p>
              </div>
            </section>
          </div>

          <!-- RU -->
          <div v-else class="legal-content" lang="ru">

            <section>
              <h2>1. Общая информация</h2>
              <p>Данный веб-сайт («Сайт»), доступный по адресу <strong>www.investbroker.md</strong>, управляется компанией <strong>INVEST-BROKER S.R.L.</strong>, с офисом по адресу:</p>
              <p>ул. 31 Августа 1989, № 31, Кишинёв MD-2001, Республика Молдова.</p>
              <p>Лицензия: серия CNPF № 000867, выдана 22.03.2013.</p>
              <p>Используя данный Сайт, вы («Пользователь», «Клиент» или «Покупатель») соглашаетесь соблюдать настоящие Условия («Соглашение»).</p>
            </section>

            <section>
              <h2>2. Область применения</h2>
              <p>Сайт носит информационный характер и служит для обеспечения связи между пользователями и компанией.</p>
              <p>Использование Сайта допускается исключительно в законных целях. Пользователь обязуется не:</p>
              <ul>
                <li>использовать Сайт способом, нарушающим действующее законодательство;</li>
                <li>предпринимать попытки несанкционированного доступа к системам или данным;</li>
                <li>нарушать работу или безопасность Сайта.</li>
              </ul>
            </section>

            <section>
              <h2>3. Интеллектуальная собственность</h2>
              <p>Весь контент Сайта, включая, но не ограничиваясь текстами, графикой, логотипами, дизайном и структурой, принадлежит <strong>INVEST-BROKER S.R.L.</strong> или её партнёрам и защищён законодательством об интеллектуальной собственности.</p>
              <p>Воспроизведение, распространение, изменение или использование контента без предварительного письменного согласия запрещено.</p>
            </section>

            <section>
              <h2>4. Точность информации</h2>
              <p>Информация, представленная на Сайте, носит общий информационный характер.</p>
              <p>Несмотря на то что INVEST-BROKER S.R.L. прилагает разумные усилия для обеспечения её достоверности, компания не гарантирует полноту, точность и актуальность информации в любой момент времени.</p>
              <p>Компания оставляет за собой право изменять, обновлять или удалять контент в любое время без предварительного уведомления.</p>
            </section>

            <section>
              <h2>5. Ограничение ответственности</h2>
              <p>В максимально допустимой законом мере INVEST-BROKER S.R.L. не несёт ответственности за:</p>
              <ul>
                <li>любые прямые или косвенные убытки, возникшие в результате использования или невозможности использования Сайта;</li>
                <li>ошибки или неточности в контенте;</li>
                <li>перебои, задержки или технические неполадки.</li>
              </ul>
              <p>Использование Сайта осуществляется на собственный риск пользователя.</p>
            </section>

            <section>
              <h2>6. Защита персональных данных</h2>
              <p>Сайт соответствует требованиям:</p>
              <ul>
                <li><strong>Закона № 133 от 08.07.2011 о защите персональных данных (Республика Молдова)</strong>;</li>
                <li><strong>Общего регламента о защите данных (GDPR)</strong>, где применимо.</li>
              </ul>
              <p>Персональные данные обрабатываются законно, справедливо и прозрачно.</p>
              <p>Пользователи вправе:</p>
              <ul>
                <li>получить доступ к своим персональным данным;</li>
                <li>запросить их исправление или удаление;</li>
                <li>ограничить обработку или возразить против неё;</li>
                <li>отозвать согласие, где это применимо.</li>
              </ul>
              <p>По всем вопросам, связанным с персональными данными: <strong>contact@investbroker.com</strong></p>
            </section>

            <section>
              <h2>7. Файлы cookie и аналитика</h2>
              <p>Сайт использует файлы cookie и сторонние инструменты, включая <strong>Google Analytics</strong>, для:</p>
              <ul>
                <li>улучшения пользовательского опыта;</li>
                <li>анализа трафика и поведения на Сайте.</li>
              </ul>
              <p>Используя Сайт, вы даёте согласие на использование файлов cookie. Ими можно управлять или отключить их в настройках браузера.</p>
            </section>

            <section>
              <h2>8. Ссылки на третьи стороны</h2>
              <p>Сайт может содержать ссылки на сторонние веб-сайты.</p>
              <p>Они предоставляются исключительно для удобства, и INVEST-BROKER S.R.L. не несёт ответственности за их контент или политики.</p>
            </section>

            <section>
              <h2>9. Изменения</h2>
              <p>Компания оставляет за собой право изменять настоящие Условия в любое время без предварительного уведомления.</p>
              <p>Продолжение использования Сайта означает принятие внесённых изменений.</p>
            </section>

            <section>
              <h2>10. Применимое право</h2>
              <p>Настоящие Условия регулируются законодательством Республики Молдова.</p>
              <p>Все споры подлежат разрешению в компетентных судах Республики Молдова.</p>
            </section>

            <section>
              <h2>11. Контактные данные</h2>
              <div class="contact-block">
                <p>По вопросам или запросам, связанным с настоящими Условиями:</p>
                <p><strong>contact@investbroker.com</strong></p>
              </div>
            </section>
          </div>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'TermsView',
  data() {
    return {
      lang: localStorage.getItem('lang') || 'Ro'
    }
  },
  mounted() {
    window.addEventListener('storage', this.onStorageChange)
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.onStorageChange)
  },
  methods: {
    onStorageChange(e) {
      if (e.key === 'lang') {
        this.lang = e.newValue || 'Ro'
      }
    }
  }
}
</script>

<style scoped>
.terms-page {
  background: #fff;
  min-height: 100vh;
}

.container-main {
  margin-top: 150px;
  padding-bottom: 100px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  font-size: 0.95rem;
  color: rgb(46, 46, 46);
  letter-spacing: -0.02em;
}

.breadcrumb-link {
  color: #1CA5BE;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.breadcrumb-link:hover {
  color: rgb(18, 129, 149);
}

.breadcrumb-sep {
  color: rgba(46, 46, 46, 0.4);
}

.breadcrumb-current {
  color: rgba(46, 46, 46, 0.6);
}

.page-title {
  font-size: 3rem;
  font-weight: 500;
  letter-spacing: -2.2px;
  color: rgb(46, 46, 46);
  text-align: center;
  margin-bottom: 60px;
}

.legal-content {
  text-align: left;
}

.legal-content .meta {
  font-size: 0.95rem;
  color: rgba(46, 46, 46, 0.6);
  margin-bottom: 32px;
}

.legal-content section {
  margin-bottom: 40px;
}

.legal-content h2 {
  font-size: 1.4rem;
  font-weight: 500;
  color: #1CA5BE;
  letter-spacing: -0.5px;
  margin-bottom: 12px;
  margin-top: 8px;
}

.legal-content p {
  font-size: 1rem;
  line-height: 1.7;
  color: rgb(46, 46, 46);
  margin-bottom: 12px;
}

.legal-content ol,
.legal-content ul {
  margin-left: 1.4rem;
  color: rgb(46, 46, 46);
}

.legal-content li {
  font-size: 1rem;
  line-height: 1.7;
  margin-bottom: 6px;
}

.legal-content ul li::marker {
  color: #1CA5BE;
}

.contact-block {
  background: rgba(28, 165, 190, 0.06);
  border-left: 3px solid #1CA5BE;
  border-radius: 0 6px 6px 0;
  padding: 20px 24px;
}

.contact-block p {
  margin-bottom: 8px;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 2rem;
    letter-spacing: -1.5px;
  }

  .legal-content h2 {
    font-size: 1.1rem;
  }

  .container-main {
    margin-top: 100px;
    padding-bottom: 80px;
  }
}
</style>
